
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Jai Hanuman gyan gun sagar" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Jai Hanuman gyan gun sagar" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shri Hanuman Chalisa, Jai Hanuman Gyan Gun Sagar, bajarangbali prayer, hanuman devotion, Hanuman mantra'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jai Hanuman Gyan Gun Sagar, Shri Hanuman Chalisa, Hanuman prayer, Lord Hanuman stotra, Hanuman devotion, Bajrangbali prayer, Hanuman mantra, Chalisa chanting, हनुमान चालीसा हिंदी में,  हनुमान चालीसा, जय जय हनुमान गोसाई, Hanuman Chalisa Lyrics, Hanuman Chalisa Lyrics marathi, Hanuman Chalisa Lyrics english' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/hanuman-chalisa.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/hanuman-chalisa.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Jai Hanuman gyan gun sagar | Shri Hanuman Chalisa - जय हनुमान ज्ञान गुन सागर(श्री गणेश चालीसा)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/hanuman-chalisa"
        },
        "headline": "Jai Hanuman gyan gun sagar - जय हनुमान ज्ञान गुन सागर(श्री गणेश चालीसा)",
        "name" : "Jai Hanuman gyan gun sagar - Shri Hanuman Chalisa",
        "description": "Explore the full lyrics of stotra 'Jai Hanuman gyan gun sagar' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/hanuman-chalisa.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  